import React, { useEffect, useState } from "react";
import KeysContainer from "../components/servicesComponents/KeysContainer";
import ServicesContainer from "../components/servicesComponents/ServicesContainer";
import classes from "./EditServices.module.scss";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import ServicesTable2 from "../components/servicesComponents/servicesTable/ServicesTable2";
import { DDD, E2Data } from "../lib/ddd/ddd";
import Cookies from 'js-cookie'

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2data = new E2Data("EU_AOrg_ServicesEndpoints");
//e2data.filter = "Valid=true";
e2data.format = "full";

const EditServices = () => {
  const [isAnaf, setIsAnaf] = useState(null);
  const [anafError, setAnafError] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const check = urlParams.get('check');
    if(check === "anaf"){
      checkForError();
    }
  },[]);
  //{"Status":"OK","Result":{"AccessToken":"File/db940902-6f42-49fc-852b-64a163554884?inline=true","RefreshToken":"File/3de89099-7d06-49c0-9686-6f84bf5a9516?inline=true","AccessTokenValidTo":"2024-09-30T14:45:06+02:00","RefreshTokenValidTo":"2025-06-27T14:45:06+02:00"},"ResultType":"Custom"}
  const handleAnaf = (data) => {
    /*const dd = new DDD(apiRequestAddress);
      dd.Rpc_ExecuteExtension("EUeInvoices.OAuthOrRefreshTokenActive", { "SiteAcronym":"AnafRO"}).then(res => {
          if(res?.result.Result.HasValidAccessToken === true){
            setIsAnaf(true);
          }
          if(res?.result?.Status === "Error"){
            setAnafError(res?.result?.Reason);
          }
      });*/
      /* e2data.values = data.Result;
      e2data.filter = "ServiceEndPointCode = 'ROe-Invoice'";
      e2data.Modify().then(res => {
        setIsAnaf(true);
        setReloadData(1+Math.random());
      }); */
      setIsAnaf(true);
      setReloadData(1+Math.random());
  };

  const checkForError = () => {
    const cookie = getCookies();
    if(cookie){
      if(cookie.Status==="Error"){
        setAnafError(cookie.Reason||"An error occurred");
      }else{
        handleAnaf(cookie);
      }
    }else{
      setAnafError("No cookie found. Contact support.");
    }
  }

  const getCookies = () => {
    const val = Cookies.get('oauth-response');
    Cookies.remove('oauth-response');
    if(val){
      try{
          const g = JSON.parse(val);
          return g;
      }catch{
          return null;
      }
    }
    return null;
  }

  return (
    <>
      <Helmet>
        <title>API keys & Credentials | DDD Invoices</title>
      </Helmet>
      <div className={`h-100 w-100 p-5 ${classes.container}`}>
        {isAnaf && (
          <div className="alert alert-success" role="alert">
            Token successfully generated
          </div>
        )}
        {anafError && (
          <div className="alert alert-danger" role="alert">
            {anafError}
          </div>
        )}
        <ServicesTable2 reloadData={reloadData}/>
        {/*<KeysContainer />*/}
        {/*<ServicesContainer />*/}
      </div>
    </>
  );
};

export default EditServices;
